import { apiService } from "../apiService";
import urlConfig from "../../config/domain";
import { ILeadFormFields } from "../../components/login/forms/leadForm";
import loginURLConfig from "../../config/login/loginURLConfig";

export const AGetValidateUserId = (// export const AGetSecurityImage = (
  callback: CallableFunction,
  userId: string,
  logo: boolean
) => {
  apiService(
    {
      url: loginURLConfig.account + "validateuser/" + userId + "?ff=W&logo=" + logo,// url: loginURLConfig.accounts + userId + "/image?ff=W&logo=" + logo,
      method: "GET",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
    },
    callback
  );
};

export const AValidatePassword = (// export const A2faQuestions = (
  callback: CallableFunction,
  userId: string,
  accTyp: string,
  pwd: string
) => {
  apiService(
    {
      url: loginURLConfig.account + "validatepassword/" + userId,// url: loginURLConfig.accounts + userId + "/2faquestions",
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body: { 
        pwd, 
        accTyp, 
        ff: "W", 
        ip: "", 
        vndSrc: "API" 
      },
    },
    callback
  );
};

export const ATotpLogin = (
  callback: CallableFunction,
  userId: string,
  accTyp: string,
  pwd: string,
  totp: string,
  loginFlow: string,
) => {
  apiService(
    {
      url: loginURLConfig.account + userId + "/totplogin" ,

      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body: { pwd, accTyp, totp, ip:"", loginFlow, pL: true},
    },
    callback
  );
};

export const A2FaLogin = ( //export const AVerifyAnswers = (
  callback: CallableFunction,
  userId: string,
  accTyp: string,
  pwd: string,
  otp: string
) => {
  apiService(
    {
      url: loginURLConfig.account + "2falogin/" + userId,// url: loginURLConfig.accounts + userId + "/verifyanswers/v2",
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body: {
        pwd: pwd,
        twoFactor: otp,
        accTyp,
        pL: true,
        appData: { vendor: sessionStorage.getItem("source") || undefined },
        vndSrc: "API",
      },
    },
    callback
  );
};

export const getTncConsent = (callback: CallableFunction, userId: string) => {
  apiService(
    {
      url:
        loginURLConfig.consent +
        "loginconsent/" +
        userId +
        "?consentName=APIConsent",
      method: "GET",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      // body: { ip: "", consents: [{ cnsntNm:body.cnsntNm, sts:body.sts }], }
    },
    callback
  );
};
export const SubmitTnc = (
  callback: CallableFunction,
  usrId: string,
  body: any
) => {
  apiService(
    {
      url: loginURLConfig.consent + "loginconsent/" + usrId,
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body: { ip: "", consents: [{ cnsntNm: body.cnsntNm, sts: body.sts }] },
    },
    callback
  );
};

export const AForgotLoginId = (callback: CallableFunction, body: any) => {
  apiService(
    {
      url: loginURLConfig.CommKambala?(loginURLConfig.loginHelp + "forgotuserid"):(loginURLConfig.accounts + "forgotuserid"),
      method: loginURLConfig.CommKambala ? "POST" : "PUT",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};

export const AForgotPassword = (
  callback: CallableFunction,
  { loginId, ...body }: any
) => {
  apiService(
    {
      url: loginURLConfig.accounts + loginId + "/resetpassword",
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};

export const AForgotPasswordOTP = (
  callback: CallableFunction,
  { loginId, ...body }: any
) => {
  apiService(
    {
      url: loginURLConfig.loginHelp + "otp/" + loginId,
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};
export const AValidateOTP = (
  callback: CallableFunction,
  { loginId, ...body }: any
) => {
  apiService(
    {
      url: loginURLConfig.accounts + loginId + "/forgotpassword/validateotp",
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};
export const AClientResetPassword = (
  callback: CallableFunction,
  { loginId, ...body }: any
) => {
  apiService(
    {
      url: loginURLConfig.accounts + loginId + "/setpassword",
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body: {
        nePwd: body.password,
        coPwd: body.confirmPassword,
        accTyp: "EQ",
      },
    },
    callback
  );
};

export const AClientKamResetPassword = (
  callback: CallableFunction,
  { loginId, ...body }: any,
  accTyp: string,
) => {
  apiService(
    {
      url: loginURLConfig.loginHelp + "setpassword/" + loginId,
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body: {
        nePwd: body.password,
        coPwd: body.confirmPassword,
        otp: body.otp,
        accTyp,
      },
    },
    callback
  );
};

export const AUnblockAccount = (
  callback: CallableFunction,
  { loginId, ...body }: any
) => {
  apiService(
    {
      url: loginURLConfig.CommKambala ? loginURLConfig.loginHelp + "unblockuser/" + loginId : loginURLConfig.accounts + loginId + "/unblockuser",
      method: loginURLConfig.CommKambala ? "POST" : "PUT",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};

export const AForgotYob = (
  callback: CallableFunction,
  { loginId, ...body }: any
) => {
  apiService(
    {
      url: loginURLConfig.accounts + loginId + "/yob",
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};

export const AGetCities = (callback: CallableFunction, srchstr: string) => {
  apiService(
    {
      url: loginURLConfig.commAccOpen + "location?srchstr=" + srchstr,
      method: "GET",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
    },
    callback
  );
};

export const ACommAccOpenPre = (
  callback: CallableFunction,
  body: ILeadFormFields
) => {
  apiService(
    {
      url: loginURLConfig.commAccOpen + "prelogin",
      method: "POST",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      body,
    },
    callback
  );
};

export const ASaveQueryData = (callback: CallableFunction, value: any) => {
  apiService(
    {
      url: loginURLConfig.adhoc + "save/data",
      method: "POST",
      appidkey: urlConfig.appidkey,
      body: { value: JSON.stringify(value) },
    },
    callback
  );
};

//  Vendor Api call

export const vendorLogin = (
  callback: CallableFunction,
  value: any,
  headers: any
) => {
  apiService(
    {
      url: loginURLConfig.vendor_login,
      method: "POST",
      authType: "encryption",
      appidkey: urlConfig.appidkey,
      body: value,
      headers,
    },
    callback
  );
};
export const vendorForgotPassword = (
  callback: CallableFunction,
  body: any,
  headers: any
) => {
  apiService(
    {
      url: loginURLConfig.vendor_forget_password,
      method: "POST",
      appidkey: urlConfig.appidkey,
      authType: "encryption",
      headers: headers,
      body: body,
    },
    callback
  );
};

export const vendorResetPassword = (
  callback: CallableFunction,
  body: any,
  headers: any
) => {
  apiService(
    {
      url: loginURLConfig.vendor_reset_password,
      method: "PUT",
      appidkey: urlConfig.appidkey,
      authType: "encryption",
      headers: headers,
      body: body,
    },
    callback
  );
};
